export const mockAPIPath = {
    DEMO_USER_LIST:"",
    DEMO_STUCK_TRANSACTION:"",
    DELETE_DEMO_STUCKED_TRANSACTION:"",

};
 
export const serverAPIPath = {
    DEMO_USER_LIST:"/demo/users",
    CREATE_DEMO_USER:"/demo/users",
    REVOKE_DEMO_USER:"/demo/users/revoke",
    DEMO_USER_INVITATION:"/demo/users/invite",
    DEMO_STUCK_TRANSACTION:"/demo/stuck-transaction",
    DELETE_DEMO_STUCKED_TRANSACTION:"/demo/stuck-transaction",

};